import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetCustomerLoyalty = async (
  customerId: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/loyalty/balance`, {
      params: { customer_id: customerId },
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load loyalty balance.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const RedeemLoyaltyPoints = async (payload: {
  customer_id: string;
  points: number;
  order_id?: string;
  order_total?: number;
  store_id?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/loyalty/redeem`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to redeem loyalty points.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const SendLoyaltyCardWhatsApp = async (
  customerId: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/loyalty/send-card`, {
      customer_id: customerId,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to send WhatsApp membership card.",
      error: {
        code: error?.response?.status || 502,
        type: "server_error",
      },
    };
  }
};

export const GetLoyaltyTransactions = async (
  customerId: string,
  limit = 50,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/loyalty/transactions`, {
      params: { customer_id: customerId, limit },
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to load loyalty transactions.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};
